import { connect } from 'react-redux';
import Loader from './Loader';

const mapStateToProps = state => ({

});

const mapDispatchToProps = {
  
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Loader);
